// extracted by mini-css-extract-plugin
export default {"div":"ScrollId_div__MrsVw"};